const BETA_CONFIG_STRING = `ExpenseTrackingServiceGamma-CognitoStack-gamma.ExpenseTrackingServiceGammaIdentityPoolId = us-west-1:b6ac1edc-d6a0-4d9a-a940-23d0dd9e581c
ExpenseTrackingServiceGamma-CognitoStack-gamma.ExpenseTrackingServiceGammaUserPoolIdgamma = us-west-1_L0HWlDf4Y
ExpenseTrackingServiceGamma-CognitoStack-gamma.ExpenseTrackingServiceGammaUserPoolclientgamma = 7re4lu3hn47u3i2984oetfhkof`;

const GAMMA_CONFIG_STRING = `ExpenseTrackingServiceGamma-CognitoStack-gamma.ExpenseTrackingServiceGammaIdentityPoolId = us-west-1:b6ac1edc-d6a0-4d9a-a940-23d0dd9e581c
ExpenseTrackingServiceGamma-CognitoStack-gamma.ExpenseTrackingServiceGammaUserPoolIdgamma = us-west-1_L0HWlDf4Y
ExpenseTrackingServiceGamma-CognitoStack-gamma.ExpenseTrackingServiceGammaUserPoolclientgamma = 7re4lu3hn47u3i2984oetfhkof`;
const PROD_CONFIG_STRING = `ExpenseTrackingService-CognitoStack-prod.ExpenseTrackingServiceIdentityPoolId = us-west-2:d7dd0d92-e1cb-4330-a4fa-f3a6d0595045
ExpenseTrackingService-CognitoStack-prod.ExpenseTrackingServiceUserPoolIdprod = us-west-2_ZBbmI8LMv
ExpenseTrackingService-CognitoStack-prod.ExpenseTrackingServiceUserPoolclientprod = 5ntth4opb90up81gfiam3r7qk5`;

// const GAMMA_CONFIG_STRING =
const PROD_CONFIG = {
  ...getCognitoConfigFromString(PROD_CONFIG_STRING),
  PROFILE_SVC_URL: "https://prod-profileexp.service.crz97.com",
  LOGIN_DOMAIN: "prod-kokofin-auth.auth.us-west-2.amazoncognito.com",
  STAGE: "prod",
};

const GAMMA_CONFIG = {
  ...getCognitoConfigFromString(GAMMA_CONFIG_STRING),
  PROFILE_SVC_URL: "https://gamma-profileexp.service.crz97.com",
  LOGIN_DOMAIN: "gamma-kokofin-auth.auth.us-west-1.amazoncognito.com",
  STAGE: "gamma",
};

const BETA_CONFIG = {
  ...getCognitoConfigFromString(BETA_CONFIG_STRING),
  PROFILE_SVC_URL: "https://gamma-profileexp.service.crz97.com",
  LOGIN_DOMAIN: "gamma-kokofin-auth.auth.us-west-1.amazoncognito.com",
  STAGE: "gamma",
};
export const isProdStage = window.location.href.includes("kokofin.com");
export const CONFIGS = isProdStage ? PROD_CONFIG : GAMMA_CONFIG;

function getCognitoConfigFromString(config) {
  const configLines = config.split("\n");
  const USER_POOL_ID = configLines[1].split("=")[1].trim();
  return {
    REGION: USER_POOL_ID.split("_")[0],
    USER_POOL_ID: USER_POOL_ID,
    USER_POOL_CLIENT_ID: configLines[2].split("=")[1].trim(),
    IDENTITY_POOL_ID: configLines[0].split("=")[1].trim(),
  };
}
